import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import '@/style/home.scss'
import Reveal from '@/components/Reveal'
import heroImg from '@/images/site/hero-home.jpg'
import visionImg from '@/images/site/vision.jpg'

const STATS = [
  { value: '2008', label: '公司成立' },
  { value: '1000万', label: '注册资本' },
  { value: '涿州', label: '河北保定' },
  { value: '5', label: '应用领域' },
]

const VISION = [
  {
    title: '企业目标',
    content:
      '丰源电力科技（涿州）有限公司始终以“发展绝缘材料产业，打造质量可靠产品”为企业目标，依靠先进的工艺、过硬的质量、优质的服务赢得客户的信赖，并成为多个领域企业集团的合格供应商。',
  },
  {
    title: '企业愿景',
    content:
      '我们的愿景是成为五金行业的领先者，通过不断创新和卓越品质，为客户提供最优质的解决方案，促进行业的可持续发展，共创美好未来。',
  },
]

const BUSINESS = [
  { icon: require('@/images/industry/SMC加工件.jpg'), content: '加工件', href: '/industry?type=industryShow' },
  { icon: require('@/images/industry/SMC模压件 (1).jpg'), content: 'SMC/DMC 模压制品', href: '/industry?type=industryShow' },
  { icon: require('@/images/industry/PC板加工件.jpg'), content: '型材', href: '/industry?type=industryShow' },
  { icon: require('@/images/industry/树脂板加工件.jpg'), content: '模塑件', href: '/industry?type=industryShow' },
]

function Home() {
  const navigate = useNavigate()

  // 首次进入时若带锚点，滚动到对应区块
  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    const el = document.getElementById(type)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      {/* ---------- 首屏 ---------- */}
      <section className="hero">
        <div className="hero__bg" style={{ backgroundImage: `url(${heroImg})` }} aria-hidden="true" />
        <div className="hero__scrim" aria-hidden="true" />
        <div className="hero__grid" aria-hidden="true" />

        <div className="mainContent hero__inner">
          <div className="hero__text">
            <p className="hero__eyebrow">FENGYUAN ELECTRIC &nbsp;·&nbsp; EST. 2008</p>
            <h1 className="hero__title">
              发展绝缘材料产业
              <br />
              <span>打造质量可靠产品</span>
            </h1>
            <p className="hero__desc">
              丰源电力科技（涿州）有限公司，专业从事电工绝缘材料的开发、设计与应用，
              产品广泛应用于石油化工、电力、电气、电子与机械等领域。
            </p>
            <div className="hero__actions">
              <a className="btn btn--volt" href="/industry?type=industryShow">
                查看产品
                <svg className="btn__arrow" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M1 7h11M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a className="btn btn--ghost" href="/contact?type=contactUs">联系我们</a>
            </div>
          </div>
        </div>

        <div className="hero__statsBar">
          <div className="mainContent hero__stats">
            {STATS.map((s) => (
              <div className="hero__stat" key={s.label}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- 企业目标 / 愿景 ---------- */}
      <section className="section section--soft vision">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">About Us</p>
            <h2 className="secHead__title">企业目标与企业愿景</h2>
          </Reveal>

          <div className="vision__grid">
            <Reveal className="vision__media" delay={80}>
              <img src={visionImg} alt="丰源电力生产车间" />
              <div className="vision__badge">
                <strong>涿州 · 河北</strong>
                <span>总部与生产基地</span>
              </div>
            </Reveal>

            <div className="vision__list">
              {VISION.map((item, i) => (
                <Reveal className="vision__item" key={item.title} delay={160 + i * 120}>
                  <span className="vision__index">0{i + 1}</span>
                  <h3 className="vision__title">{item.title}</h3>
                  <p className="vision__content">{item.content}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ---------- 主营品类 ---------- */}
      <section className="section business">
        <div className="mainContent">
          <Reveal className="secHead center">
            <p className="secHead__eyebrow">Products</p>
            <h2 className="secHead__title">主营品类</h2>
            <p className="secHead__desc">
              覆盖板料、模压制品、工程型材与模塑件四大品类，可按图纸定制加工。
            </p>
          </Reveal>

          <div className="business__grid">
            {BUSINESS.map((item, i) => (
              <Reveal key={item.content} delay={i * 90}>
                <button className="business__card" type="button" onClick={() => navigate(item.href)}>
                  <span className="business__media">
                    <img src={item.icon} alt={item.content} loading="lazy" />
                  </span>
                  <span className="business__body">
                    <span className="business__title">{item.content}</span>
                    <span className="business__more">
                      查看详情
                      <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                        <path d="M1 7h11M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- 联系方式 ---------- */}
      <section className="section section--dark section--grid cta">
        <div className="mainContent cta__inner">
          <Reveal>
            <h2 className="cta__title">与我们<span>取得联系</span></h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="cta__desc">
              河北省保定市涿州市高官庄镇解家楼村村北
              <br />
              139 1110 2112 &nbsp;·&nbsp; 120299424@qq.com
            </p>
          </Reveal>
          <Reveal delay={200} className="cta__actions">
            <a className="btn btn--volt" href="/contact?type=contactUs">联系我们</a>
            <a className="btn btn--ghost" href="/intro?type=overview">了解我们</a>
          </Reveal>
        </div>
      </section>
    </>
  )
}

export default Home